<template>
  <div v-if="data.show" class="turnkey row align-center">
    <i v-if="data.close" class="close fa fa-times" @click="data.close" title="FECHAR" />
    <div class="range" :class="data.on ? 'on' : 'off'" @click="data.toggle()">
      <div class="pin"></div>
    </div>
    <span :class="data.on ? 'on' : 'off'" @click="data.toggle()">
      {{
        data.on && data.label ? data.label.on || "" : (data.label && data.label.off) || ""
      }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Turnkey",
  props: ["data"],
};
</script>
<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.turnkey
  cursor: pointer
  .close
    color: $red
    margin: 12px
    font-size: 14px
  span
    color: #fff
    font-weight: bold
    margin-left: 9px
    color: $font-color
    letter-spacing: 1.6px
    font-size: 14px

  .range
    border-radius: 30px
    height: 32px
    width: 60px
    
    .pin
      width: 33px
      height: 33px
      background: white
      border-radius: 50%
      
      margin-top: -3px
    &.off
      background: $red-3
      .pin
        border: 3px solid $red-3

    &.on
      background: $supporter-1
      .pin
        margin-left: 24px
        border: 3px solid $supporter-1
</style>
